// Keep the rendered image and the document preload on the same hosted asset.
export var heroImage = 'https://www.static-immobilienscout24.de/statpic/agent-search-web/b72fced4b0a780df3fc490c6dc925238_hero.jpg';